export default "{\n    \"title\": \"Detalles del Mantenimiento Preventivo\",\n    \"breadcrumbsParentLinkText\": \"Mantenimiento Preventivo\"\n}\n"